// this is an autogenerated file from App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_Content_Content_CollapsibleSidebar_MonthlyCalendar(
  $location_id: uuid!
  $appointment_type_id: uuid
  $appointment_id: uuid
  $start_date: date!
  $end_date: date!
  $duration: Int
  $patient_id: uuid
  $include_slots: Boolean!
  $include_preferences: Boolean!
) {
  metrics: calendar_get_daily_calendar_metrics(
    args: {
      _location_id: $location_id
      _start_date: $start_date
      _end_date: $end_date
    }
  ) {
    id
    office_day_date
    appointments
    patients
    exams
    starts
    percentage_of_occupancy
    appointment_templates
    office_day {
      id
      template {
        id
        name
        color
      }
    }
  }
  allocations: vaxiom_chair_allocations(
    where: {
      ca_date: { _gte: $start_date, _lte: $end_date }
      resource: {
        organization: { _id: { _eq: $location_id } }
        resource_type: {
          _or: [{ is_assistant: { _eq: true } }, { is_provider: { _eq: true } }]
        }
      }
    }
    order_by: { ca_date: asc }
  ) {
    id
    chair {
      _id
    }
    ca_date
    resource {
      id
      employee_resources {
        id
        _id
        employment_contract {
          id
          person {
            id
            greeting
            first_name
            last_name
          }
        }
      }
      resource_type {
        id
        is_assistant
        is_provider
      }
    }
  }
  slots: calendar_scheduling_get_candidate_slots(
    args: {
      _appointment_type_id: $appointment_type_id
      _location_id: $location_id
      _start_date: $start_date
      _end_date: $end_date
      _appointment_id: $appointment_id
      _duration: $duration
    }
    order_by: { date: asc, start_min: asc }
  ) @include(if: $include_slots) {
    # keep synced with apps/admin/src/Data/ApiCacheExchangeKeys.js (urql cache id)
    xid
    chair_id
    date
    start_min
    end_min
  }
  preferences: vaxiom_scheduling_preferences(
    where: { patient: { _id: { _eq: $patient_id } } }
  ) @include(if: $include_preferences) {
    id
    start_hour
    end_hour
    days: scheduling_preferences_week_days {
      week_days
    }
    employees: scheduling_preferred_employees {
      employee {
        _id
        id
        resource {
          id
          resource_type {
            id
            is_provider
            is_assistant
          }
        }
      }
    }
  }
}

`